import { useContext, useEffect, useState, useRef } from "react"
import { Link, useMatch, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import Spinner from "../../../components/BootstrapCompo"
import { GlobalContext, handleError } from "../../../context/Provider"
import henceforthApi from "../../../utils/henceforthApi"
import SignedImage from "../../../components/SignedImage"

const CategoryEdit = () => {
    const match = useMatch("/category/level-1/edit/:name/:type/:id")
    const navigate = useNavigate()
    const [categoryNameError, setCategoryError] = useState("")
    const [categoryName, setCategoryName] = useState(match?.params.name)
    const [loading, setloading] = useState(false)
    const [productType, setProductType] = useState(match?.params.type)
    const [imageError, setImageError] = useState("")
    const [selectedFile, setSelectedFile] = useState<any>(null)
    const [existingImage, setExistingImage] = useState("")
    const fileInputRef = useRef<HTMLInputElement>(null)
    const { authState } = useContext(GlobalContext);



    const fileUpload = async () => {
        try {
            const apiRes = await henceforthApi.Common.do_spaces_file_upload("file", selectedFile)
            const data = apiRes.data
            return data.file_name
        } catch (error) {
            handleError(error)
            return ""
        }
    }

    const initializeCategory = async () => {
        try {
            let apiRes = await henceforthApi.Category.listCategory(`_id=${match?.params.id}`)

            console.log('API Response:', apiRes.data)
            if (apiRes?.data) {
                const category = apiRes.data.data[0]
                console.log('Category data:', category)
                setCategoryName(category.name)
                setProductType(category.design_type)
                setExistingImage(category.image || "")
                console.log('Existing image set to:', category.image)
            }
        } catch (error) {
            handleError(error)
        }
    }

    useEffect(() => {
        initializeCategory()
    }, [match?.params.id])

    const editCategory = async (e: any) => {
        e.preventDefault()
        if (!categoryName) {
            return setCategoryError("Please Enter Category Name")
        }
        if (!categoryName) return setCategoryError("Please Enter Category Name")
        setloading(true)
        try {
            let image = existingImage
            if (selectedFile) {
                const uploadedImage = await fileUpload()
                if (uploadedImage) {
                    image = uploadedImage
                }
            }

            const data = {
                _id: match?.params.id,
                name: categoryName,
                product_type: productType,
                ...(image && { image: image }),
                language: authState.lang
            }
            let apiRes = await henceforthApi.Category.editCategory(data)
            toast.success("Category updated successfully")
            window.history.back()
        } catch (error) {
            handleError(error)
        } finally {
            setloading(false)
        }
    }
    return (
        <>
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            {/* title  */}
                            <h2 className="fw-semibold">Edit Categories</h2>
                            {/* breadcrum  */}
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/category/level-1/1">Category Level</Link></li>
                                    <li className="breadcrumb-item active fw-bold">Edit Categories</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            {/* page  */}
            <div className='page-spacing'>
                <section className='product-detail'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-sm-10 col-md-6 col-lg-5 col-xl-4 col-xxl-3">
                                {/* Title  */}
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Edit Categories</h5>
                                    </div>
                                    <div className="common-card-content">
                                        <form onSubmit={editCategory} >
                                            {/* Upload image */}
                                            <div className='upload-fields-box mb-4'>
                                                <label className="mb-1 fw-bold">Category Image:</label>
                                                <div className='d-flex align-items-start gap-3' style={{ position: 'relative' }}>
                                                    <div
                                                        style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            border: '2px dashed #ccc',
                                                            borderRadius: '8px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: '#f8f9fa',
                                                            flexShrink: 0,
                                                            cursor: 'pointer',
                                                            overflow: 'hidden'
                                                        }}
                                                        onClick={() => (fileInputRef.current as HTMLInputElement)?.click()}
                                                    >
                                                        {selectedFile ? (
                                                            <img
                                                                src={URL.createObjectURL(selectedFile)}
                                                                alt="Category"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                            />
                                                        ) : existingImage ? (
                                                            <div style={{ width: '100%', height: '100%', overflow: 'hidden', borderRadius: '8px' }}>
                                                                <SignedImage
                                                                    src={existingImage.startsWith('http') ? existingImage : existingImage}
                                                                    alt="Category"
                                                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                                                    size="original"
                                                                />
                                                            </div>
                                                        ) : (
                                                            <i className="fa fa-image" style={{ fontSize: '40px', color: '#6c757d' }}></i>
                                                        )}
                                                    </div>
                                                    <div className='flex-grow-1' style={{ position: 'relative' }}>
                                                        <input
                                                            type="file"
                                                            ref={fileInputRef}
                                                            accept="image/png,image/jpeg,image/jpg"
                                                            onChange={(e: any) => {
                                                                setSelectedFile(e.target.files[0])
                                                                setImageError("")
                                                            }}
                                                            style={{ display: 'none' }}
                                                        />

                                                    </div>
                                                </div>
                                                <p><small><strong>Note:-</strong> Please upload only .jpg and .png format only. (Optional)</small></p>
                                                {/* error msg  */}
                                                <div className={`${imageError ? "invalid-feedback d-block" : ""}`}>
                                                    {imageError}
                                                </div>
                                            </div>
                                            {/* Input Field  */}
                                            <div className="form-fields-box mb-3 is-invalid">
                                                <label className="mb-1 fw-semibold">Category Name:</label>
                                                <input type="text" placeholder="Category Name" className={`form-control ${categoryNameError ? `is-invalid` : ``} rounded-0`} value={categoryName} maxLength={55}
                                                    onChange={(e: any) => { if (categoryNameError) { setCategoryError("") } setCategoryName(e.target.value) }} />
                                                {/* error msg  */}
                                                <div className={`${categoryNameError ? "invalid-feedback" : ""}`}>
                                                    {categoryNameError}
                                                </div>
                                            </div>
                                            {/* <div className="form-select-box mb-4">
                                                <label className="mb-1 fw-semibold">Product Type:</label>
                                                <select className="form-select" aria-label="Default select example" value={productType} onChange={(e) => setProductType(e.target.value)}>
                                                    <option value='WEARABLE_PRODUCT'>WEARABLE PRODUCT</option>
                                                    <option value='ELECTRONIC_PRODUCT'>ELECTRONICS</option>
                                                </select>
                                            </div> */}
                                            {/* Button  */}
                                            <div className="button-box">
                                                <button type="submit" className='btn btn-theme w-100' disabled={loading}>{loading ? <Spinner /> : "Edit Category"}</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}
export default CategoryEdit